import {
  SLACK_SETTING_REQUEST,
  SLACK_SETTING_SUCCESS,
  SLACK_SETTING_ERROR,
  SLACK_SETTING_SET,
  SLACK_SETTING_CREATE_REQUEST,
  SLACK_SETTING_DELETE_REQUEST,
  SLACK_SETTING_DELETE_SUCCESS,
  SLACK_SETTING_DELETE_ERROR
} from './slack-setting.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import { slackSettingMetaInfo } from '@/column-header/slack/slack-setting-meta'
import { OrderByEnum } from '@/constants/orderby.constants'


const state = {
  slackSettingReqStatus: '',
  slackSettings: {},
  slackSettingDeleteReqStatus: ''
}

const getters = {
  slackSettingReqStatus: state => state.slackSettingReqStatus,
  slackSettings: state => state.slackSettings,
  slackSettingDeleteReqStatus: state => state.slackSettingDeleteReqStatus
}

// Best Practice - updates state
const mutations = {
  [SLACK_SETTING_REQUEST]: state => (state.slackSettingReqStatus = 'loading'),
  [SLACK_SETTING_SUCCESS]: state => (state.slackSettingReqStatus = 'success'),
  [SLACK_SETTING_ERROR]: state => (state.slackSettingReqStatus = 'error'),
  [SLACK_SETTING_SET]: (state, settings) => {
    state.slackSettings = settings;
  },
  [SLACK_SETTING_DELETE_REQUEST]: state => 
    (state.slackSettingDeleteReqStatus = 'loading'),
  [SLACK_SETTING_DELETE_SUCCESS]: state => 
    (state.slackSettingDeleteReqStatus = 'success'),
  [SLACK_SETTING_DELETE_ERROR]: state => 
    (state.slackSettingDeleteReqStatus = 'error')
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [SLACK_SETTING_REQUEST](context) {
    context.commit(SLACK_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest().get('setting/slack')
        .then(({ data }) => {
          data = new IQCollection(
            data,
            { attributes: slackSettingMetaInfo.meta.columns },
            { defaultSort: 'webhook_name', sortOrder: OrderByEnum.DESC }
          )

          context.commit(SLACK_SETTING_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(SLACK_SETTING_ERROR)
          reject(errMsg)
        })
    })
  },
  [SLACK_SETTING_SUCCESS]: ({ commit }) => {
    commit(SLACK_SETTING_SUCCESS)
  },
  [SLACK_SETTING_CREATE_REQUEST] (context, payload) {
    context.commit(SLACK_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('setting/slack', {
          webhookUrl: payload.webhookUrl,
          webhookName: payload.webhookName
        })
        .then(resp => {
          let data = new IQCollection(
            resp.data.data,
            { attributes: slackSettingMetaInfo.meta.columns },
            { defaultSort: 'webhook_name', sortOrder: OrderByEnum.DESC }
          )
          context.commit(SLACK_SETTING_SET, data)
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [SLACK_SETTING_DELETE_REQUEST](context, id) {
    context.commit(SLACK_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`setting/slack/${id}`, {
          webhook_id: id
        })
        .then(resp => {
          let data = new IQCollection(
            resp.data.webhooks,
            { attributes: slackSettingMetaInfo.meta.columns },
            { defaultSort: 'webhook_name', sortOrder: OrderByEnum.DESC }
          )
          context.commit(SLACK_SETTING_SET, data)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(SLACK_SETTING_DELETE_ERROR)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/slack/slack-setting.module.js